export default {
    // namespaced: true,
    state: {
        searchParams: {},
    },
    mutations: {
        search(state, value) {
            state.searchParams = value;
        },
    },
    actions: {},
}


